import { render, staticRenderFns } from "./customerService.vue?vue&type=template&id=1a5123d0&scoped=true"
import script from "./customerService.vue?vue&type=script&lang=ts"
export * from "./customerService.vue?vue&type=script&lang=ts"
import style0 from "./customerService.vue?vue&type=style&index=0&id=1a5123d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5123d0",
  null
  
)

export default component.exports